import type * as React from 'react';
import { get } from '@Domain/Api';
import rolesFetched, {
	type RolesFetchedAction,
	type RolesListFetchedPayload,
} from '@Application/Security/Roles/Actions/rolesFetched';
import rolesFetchFailed, {
	type RolesFetchFailedAction,
} from '@Application/Security/Roles/Actions/rolesFetchFailed';
import type FetchRoles from '@Application/Security/Roles/Queries/FetchRoles';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = RolesFetchedAction | RolesFetchFailedAction;

export default (query: FetchRoles) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// Server-side pagination: `get` is used deliberately, never `getPaginated` (which walks every
			// page and would make `totalRecords` lie to the paginator).
			const payload = await get<RolesListFetchedPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}/roles?${query.queryParams.toString()}`,
			);

			const action = rolesFetched(payload, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = rolesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
